import { useSelector } from 'react-redux';
import { TradingPartnerItem } from '../../redux/localReports/localReports.proptype';
import { selectTradingPartnersList } from '../../selectors';

export const useTradingPartnersList = (): TradingPartnerItem[] => {
  const tradingPartners = useSelector(selectTradingPartnersList);

  return tradingPartners;
};
